import { render, staticRenderFns } from "./TerminalForm2.vue?vue&type=template&id=443a2c70&"
import script from "./TerminalForm2.vue?vue&type=script&lang=js&"
export * from "./TerminalForm2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports